import React, { Component } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getSchool, getCartProducts } from '../modules/reducers';
import { addProductsToCart } from '../modules/actions';
import { BASEURL } from '../Config';

class UniformOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            classes: [],
            classesLoading: false,
            selectedClassId: '',
            selectedClassName: '',
            gender: '',
            catalogLoading: false,
            catalogError: '',
            products: [],
            orderTotal: 0,
        };
    }

    componentDidMount() {
        const school = this.props.school;
        if (!school || !school.name) return;
        this.setState({ classesLoading: true });
        const input = { sname: school.name, state: school.state, stype: school.type };
        axios.post(`${BASEURL}/api/v1/classes/fetch`, input)
            .then(res => {
                const all = (res.data && res.data.data && res.data.data.classesLanguages) || [];
                this.setState({ classes: all, classesLoading: false });
            })
            .catch(() => this.setState({ classesLoading: false }));
    }

    handleContinue() {
        const { selectedClassId, gender } = this.state;
        if (!selectedClassId) {
            swal('', 'Please select a class', 'warning');
            return;
        }
        if (!gender) {
            swal('', 'Please select a gender', 'warning');
            return;
        }
        const school = this.props.school;
        this.setState({ catalogLoading: true, catalogError: '' });
        axios.get(`${BASEURL}/api/v1/uniformProductCatalog/fetch/${school._id}`)
            .then(res => {
                const catalog = res.data.data;
                const filtered = catalog.products.filter(p => p.gender === gender || p.gender === 'common');
                if (filtered.length === 0) {
                    this.setState({
                        catalogLoading: false,
                        catalogError: `No uniform products available for ${gender === 'boys' ? 'Boys' : 'Girls'} in this school.`
                    });
                    return;
                }
                const products = filtered.map(p => {
                    const minQuantity = p.minQuantity != null ? p.minQuantity : 1;
                    return {
                        name: p.name,
                        gender: p.gender,
                        isMandatory: p.isMandatory,
                        isSelected: p.isMandatory,
                        selectedSize: '',
                        selectedPrice: 0,
                        minQuantity,
                        quantity: minQuantity,
                        sizes: p.sizes.filter(s => s.price > 0)
                    };
                });
                this.setState({ products, catalogLoading: false, step: 2 });
            })
            .catch(err => {
                if (err.response && err.response.status === 404) {
                    this.setState({ catalogLoading: false, catalogError: 'No uniform products are available for this school yet.' });
                } else {
                    this.setState({ catalogLoading: false, catalogError: 'Failed to load uniform products. Please try again.' });
                }
            });
    }

    handleChangeProductData(e, index) {
        let products = [...this.state.products];
        const isSelected = e.target.checked;
        const minQty = products[index].minQuantity;
        products[index] = {
            ...products[index],
            isSelected,
            selectedSize: isSelected ? products[index].selectedSize : '',
            selectedPrice: isSelected ? products[index].selectedPrice : 0,
            quantity: isSelected ? products[index].quantity : minQty
        };
        this.setState({ products, orderTotal: this.calcTotal(products) });
    }

    handleQuantityChange(index, qty) {
        let products = [...this.state.products];
        const minQty = products[index].minQuantity;
        const quantity = Math.max(minQty, parseInt(qty) || minQty);
        products[index] = { ...products[index], quantity };
        this.setState({ products, orderTotal: this.calcTotal(products) });
    }

    handleSizeSelect(index, size) {
        let products = [...this.state.products];
        const match = products[index].sizes.find(s => s.size === size);
        products[index] = {
            ...products[index],
            selectedSize: size,
            selectedPrice: match ? match.price : 0
        };
        this.setState({ products, orderTotal: this.calcTotal(products) });
    }

    calcTotal(products) {
        return products
            .filter(p => p.isSelected && p.selectedSize)
            .reduce((sum, p) => sum + p.selectedPrice * p.quantity, 0);
    }

    handleAddToCart() {
        const { products, orderTotal, selectedClassId, selectedClassName, gender } = this.state;
        const school = this.props.school;

        if (orderTotal === 0) {
            swal('Warning', 'Please select at least one product with a size.', 'warning');
            return;
        }

        const missingSize = products.filter(p => p.isSelected && !p.selectedSize).map(p => p.name);
        if (missingSize.length > 0) {
            swal('Warning', `Please select a size for: ${missingSize.join(', ')}`, 'warning');
            return;
        }

        if (this.props.cartProducts && this.props.cartProducts.length > 0) {
            swal('Warning', 'Only one product set can be added to the cart at a time. Please remove the existing item before adding a new one.', 'warning');
            return;
        }

        const cartItem = {
            productSetName: `${school.name} - Uniform Products`,
            productSetId: `${school._id}-uniforms`,
            price: orderTotal,
            categoryNames: ['Uniform Products'],
            orderType: 'uniformProducts',
            classId: selectedClassId,
            className: selectedClassName,
            gender,
            categories: {
                uniformProducts: products
                    .filter(p => p.isSelected && p.selectedSize)
                    .map(p => ({
                        name: p.name,
                        gender: p.gender,
                        isMandatory: p.isMandatory,
                        selectedSize: p.selectedSize,
                        quantity: p.quantity,
                        price: p.selectedPrice * p.quantity
                    }))
            }
        };

        this.props.addProductsToCart(cartItem);
        this.props.history.push('cart');
    }

    render() {
        const { step, classes, classesLoading, selectedClassId, gender, catalogLoading, catalogError, products, orderTotal, selectedClassName } = this.state;
        const school = this.props.school;

        return (
            <div className="site-wrap">
                <Header page={'shop'} />
                <div className="site-section">
                    <div className="container">
                        <div className='d-flex align-items-center'>
                            <a href={school && school.name ? `school/${school.name}` : '/'} className='text-black mr-3'>
                                <span className='icon icon-angle-left mr-1'></span>
                            </a>
                            <h5 className='text-primary mb-0'>Order Uniform Products</h5>
                        </div>

                        {/* ── Step 1: Class & Gender ─────────────────────────────── */}
                        {step === 1 && (
                            <div className="row mb-5 p-3">
                                {!school || !school.name ? (
                                    <div className="col-12">
                                        <div className="alert alert-warning">
                                            School information not found. Please go back and select your school.
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-md-6">
                                        <div className='table-responsive mt-3 mb-3'>
                                            <table className='table table-bordered'>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: '200px' }} className="align-middle font-weight-bold">Select Class</td>
                                                        <td>
                                                            {classesLoading ? (
                                                                <span className="text-muted">Loading classes...</span>
                                                            ) : (
                                                                <select
                                                                    className="form-control"
                                                                    value={selectedClassId}
                                                                    onChange={e => {
                                                                        const cls = classes.find(c => c._id === e.target.value);
                                                                        this.setState({
                                                                            selectedClassId: e.target.value,
                                                                            selectedClassName: cls ? cls.className : ''
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="">-- Select Class --</option>
                                                                    {classes.map(c => (
                                                                        <option key={c._id} value={c._id}>{c.className}</option>
                                                                    ))}
                                                                </select>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle font-weight-bold">Select Gender</td>
                                                        <td>
                                                            <div className="custom-control custom-radio custom-control-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="gender-boys"
                                                                    name="gender"
                                                                    className="custom-control-input"
                                                                    value="boys"
                                                                    checked={gender === 'boys'}
                                                                    onChange={() => this.setState({ gender: 'boys' })}
                                                                />
                                                                <label className="custom-control-label" htmlFor="gender-boys">Boys</label>
                                                            </div>
                                                            <div className="custom-control custom-radio custom-control-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="gender-girls"
                                                                    name="gender"
                                                                    className="custom-control-input"
                                                                    value="girls"
                                                                    checked={gender === 'girls'}
                                                                    onChange={() => this.setState({ gender: 'girls' })}
                                                                />
                                                                <label className="custom-control-label" htmlFor="gender-girls">Girls</label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {catalogError && (
                                            <div className="alert alert-info">{catalogError}</div>
                                        )}

                                        <button
                                            className='btn btn-primary'
                                            onClick={() => this.handleContinue()}
                                            disabled={catalogLoading}
                                        >
                                            {catalogLoading ? 'Loading...' : 'Continue'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ── Step 2: Product Selection ──────────────────────────── */}
                        {step === 2 && (
                            <div className="row mb-5 p-3">
                                <div className="col-12">
                                    <div className='d-flex align-items-center mb-3'>
                                        <button
                                            className='btn btn-light btn-sm mr-3'
                                            onClick={() => this.setState({ step: 1, products: [], orderTotal: 0, catalogError: '' })}
                                        >
                                            &larr; Back
                                        </button>
                                        <div>
                                            <h6 className='text-black mb-0'>
                                                Class: <span className="text-primary">{selectedClassName}</span>
                                                &nbsp;&middot;&nbsp;
                                                Gender: <span className="text-primary">{gender === 'boys' ? 'Boys' : 'Girls'}</span>
                                            </h6>
                                        </div>
                                    </div>

                                    <h6 className='text-black mb-2'>Product Type: <span className="text-primary">Uniform Products</span></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '35%' }} />
                                                <col style={{ width: '25%' }} />
                                                <col style={{ width: '90px' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    <th>Select Size</th>
                                                    <th>Qty</th>
                                                    <th>Price (Rs.)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={`uniformProduct${index}`}
                                                                    checked={item.isSelected}
                                                                    disabled={item.isMandatory}
                                                                    onChange={(e) => this.handleChangeProductData(e, index)}
                                                                />
                                                                <label className="custom-control-label" htmlFor={`uniformProduct${index}`}>
                                                                    {item.name}
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {item.isSelected ? (
                                                                <select
                                                                    className="form-control form-control-sm"
                                                                    value={item.selectedSize}
                                                                    onChange={e => this.handleSizeSelect(index, e.target.value)}
                                                                >
                                                                    <option value="">-- Select Size --</option>
                                                                    {item.sizes.map(s => (
                                                                        <option key={s.size} value={s.size}>Size {s.size}</option>
                                                                    ))}
                                                                </select>
                                                            ) : (
                                                                <span className="text-muted">—</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {item.isSelected ? (
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-sm"
                                                                    min={item.minQuantity}
                                                                    value={item.quantity}
                                                                    onChange={e => this.handleQuantityChange(index, e.target.value)}
                                                                />
                                                            ) : (
                                                                <span className="text-muted">—</span>
                                                            )}
                                                        </td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                            {item.isSelected && item.selectedSize ? `₹${item.selectedPrice * item.quantity}` : '—'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='d-flex align-items-center justify-content-between mt-3'>
                                        <h6 className='text-black mb-0'>
                                            Total: <span className='text-primary font-weight-bold'>₹{orderTotal}</span>
                                        </h6>
                                        <button
                                            className='btn btn-primary'
                                            onClick={() => this.handleAddToCart()}
                                            disabled={orderTotal === 0}
                                        >
                                            Add to Cart
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    school: getSchool(state),
    cartProducts: getCartProducts(state),
});

const mapDispatchToProps = dispatch => ({
    addProductsToCart: (products) => dispatch(addProductsToCart(products)),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(UniformOrder);
